@if (isMulti) {
  <mat-form-field appearance="outline" class="form-ultra-slim field-width-lg" subscriptSizing="dynamic">
    <mat-label>Values</mat-label>
    <mat-chip-grid #chipGrid>
      @for (v of multiValues; track $index) {
        <mat-chip-row (removed)="removeChipValue($index)">
          {{ v }}
          <button matChipRemove type="button">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
      <input matInput [matChipInputFor]="chipGrid" (matChipInputTokenEnd)="addChipValue($event)" placeholder="Add value" />
    </mat-chip-grid>
  </mat-form-field>
} @else {
  @switch (kind()) {
    @case ("boolean") {
      <mat-checkbox [checked]="!!value()" (change)="onBooleanChange($event)">{{ value() ? "True" : "False" }}</mat-checkbox>
    }
    @case ("number") {
      <mat-form-field appearance="outline" class="form-ultra-slim field-width" subscriptSizing="dynamic">
        <mat-label>Value</mat-label>
        <input matInput type="number" [value]="value()" (input)="onNumberChange($any($event.target).value)" />
      </mat-form-field>
    }
    @default {
      @if (options()) {
        <mat-form-field appearance="outline" class="form-ultra-slim field-width-lg" subscriptSizing="dynamic">
          <mat-label>Value</mat-label>
          <mat-select [value]="value()" (selectionChange)="onOptionChange($event)">
            @for (opt of options(); track opt) {
              <mat-option [value]="opt">{{ opt }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      } @else {
        <mat-form-field appearance="outline" class="form-slim field-width" subscriptSizing="dynamic">
          <mat-label>Value</mat-label>
          <input matInput [value]="value()" (input)="onTextChange($any($event.target).value)" />
        </mat-form-field>
      }
    }
  }
}
